{
  "title": "Peti masuk",
  "totalBadge": "{{count}} item",
  "viewAll": "Lihat semua",
  "loading": "Memuatkan…",
  "emptySection": "Semua selesai",
  "loadError": "Tidak dapat memuat bahagian ini"
}
